import api from "./axios";

export const createMasterCompany = async (payload) => {
  const response = await api.post("/master-company", payload);
  return response.data;
};

export const getMasterCompanies = async (payload) => {
  const response = await api.get("/master-company", payload);
  return response.data;
};

export const getMasterCompanyById = (id) => {
  return api.get(`/master-company/${id}`);
};

export const updateMasterCompany = async (id, payload) => {
  const response = await api.put(`/master-company/${id}`, payload);
  return response.data;
};

export const deleteMasterCompany = (id) => {
  return api.put(`/master-company/delete/${id}`);
};

export const getMasterCompanyList = ( params = {}) =>
  api.get(`/master-company/list`, { params });

